import React, { useEffect } from "react";
import { useState } from "react";

import {
	Stack,
	Typography,
	Box,
	// MenuItem,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Table,
	Grid,
	InputAdornment,
	IconButton,
	TablePagination,
	// TextField,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import {
	StyledTextBox,
	StyledSelectTextBox,
	StyledTextArea,
} from "../../components/TextBox";
import { StyledTableContainer, StyledTableCell } from "../../components/Table";
import SearchIcon from "@mui/icons-material/Search";
import Moment from "moment";
import { BlueBox, RedBox, YellowBox, GreenBox } from "../../components/Chip";
import Avatar from "@mui/material/Avatar";
import {
	ContainedButton,
	TextButton,
	TextButtonModal,
} from "../../components/Buttons";
import Modal from "@mui/material/Modal";
import MenuItem from "@mui/material/MenuItem";
import {
	GetRequestsCountData,
	UpdateSupportTicketStatus,
	GetSupportTicketDataPaginated,
} from "../../services/support.services";
import { parseRequestDateTime } from "../../utils/sortBy";

export default function Support() {
	const style = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "720px",
		height: "700px",
		bgcolor: "background.paper",
		// border: '2px solid #000',
		// borderTop:"6px solid red",
		// boxShadow: 24,
		p: 4,
		boxShadow: "0px 2px 8px rgba(3, 40, 120, 0.18)",
		borderRadius: "18px",
	};

	const [supportData, setSupportData] = useState(null);
	const [requestData, setRequestData] = useState(null);
	const [totalElements, setTotalElements] = useState(0);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);

	// filter states
	const [startDate, setStartDate] = useState(
		Moment().subtract(7, "days").toDate()
	);
	const [endDate, setEndDate] = useState(Moment().toDate());
	const [searchRef, setSearchRef] = useState("");
	const [filterStatus, setFilterStatus] = useState("ALL");

	const [modalValues, setModalValues] = useState({
		encryptedId: "",
		ticketreferenceNo: "",
		ticketSubject: "",
		issueType: "",
		ticketDescription: "",
		issueStatus: "",
		requestDate: "",
		requestTime: ""
	});

	const [tempStatus, setTempStatus] = useState("");

	useEffect(() => {
		if (modalValues?.ticketreferenceNo) {
			setTempStatus(modalValues.issueStatus);
			setOpen(true);
		}
	}, [modalValues]);
	const handleClose = () => {
		setModalValues({
			encryptedId: "",
			ticketreferenceNo: "",
			ticketSubject: "",
			issueType: "",
			ticketDescription: "",
			issueStatus: "",
			requestDate: "",
			requestTime: ""
		})
		setTempStatus("");
		setOpen(false)
	};

	useEffect(() => {
		(async () => {
			try {
				await GetRequestsCountData().then((data) => {
					setRequestData(data);
				});
				// Fetch paginated data with date filters and status
				await GetSupportTicketDataPaginated(page, rowsPerPage, startDate, endDate, filterStatus).then((data) => {
					setSupportData(data.elements);
					setTotalElements(data.totalElements);
				});
			} catch (error) {
				throw error;
			}
		})();
	}, [page, rowsPerPage, startDate, endDate, filterStatus]);

	if (!supportData || !requestData) return null;

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleUpdateStatus = async () => {
		try {
			setLoading(true);
			await UpdateSupportTicketStatus(
				modalValues.encryptedId,
				tempStatus
			);
			// Refresh the data after successful update with current filters
			const updatedData = await GetSupportTicketDataPaginated(page, rowsPerPage, startDate, endDate, filterStatus);
			setSupportData(updatedData.elements);
			setTotalElements(updatedData.totalElements);
			handleClose();
			console.log("Status updated successfully");
		} catch (error) {
			console.error("Error updating status:", error);
		} finally {
			setLoading(false);
		}
	};

	const STATUS_BORDER_COLOR = {
		RESOLVED: "#2E7D32",     // green
		IN_PROGRESS: "#1565C0",  // blue
		CANCELLED: "#C62828",    // red
		PENDING: "#ED6C02",      // yellow/orange
	};

	// Remove the frontend filter for displayData
	const displayData = (supportData || []).filter((row) => {
		// search by referenceNo
		if (searchRef && searchRef.trim() !== "") {
			const search = searchRef.trim().toLowerCase();
			const ref = (row.referenceNo || "").toString().toLowerCase();
			if (!ref.includes(search)) return false;
		}

		return true;
	});

	return (
		<div>
			<Stack direction="row" justifyContent="space-between" alignItems="center">
				<Typography variant="h3">Support Requests</Typography>
			</Stack>
			<br></br>

			<Box
				sx={{
					background: "#FFFFFF",
					boxShadow: "0px 2px 8px rgba(3, 40, 120, 0.18)",
					borderRadius: "18px",
					p: 5,
				}}
			>
				<Grid
					container
					spacing={2}
					justifyContent="space-between"
					alignItems="center"
				>
					<Grid item md={4}>
						<Box
							sx={{ border: "1px solid #D6D9E1", borderRadius: "8px", p: 2 }}
							alignItems="center"
						>
							<Typography variant="body1" textAlign="center">
								Total Pending Requests
							</Typography>

							<Typography
								variant="h1"
								color="primary.Primary_Blue"
								textAlign="center"
							>
								{requestData.TicketPendingCount}
							</Typography>
						</Box>
					</Grid>
					<Grid item md={4}>
						<Box
							sx={{ border: "1px solid #D6D9E1", borderRadius: "8px", p: 2 }}
						>
							<Typography variant="body1" textAlign="center">
								Total In-progress Requests
							</Typography>
							<Typography
								variant="h1"
								color="primary.Primary_Blue"
								textAlign="center"
							>
								{requestData.TicketInProgressCount}
							</Typography>
						</Box>
					</Grid>
					<Grid item md={4}>
						<Box
							sx={{ border: "1px solid #D6D9E1", borderRadius: "8px", p: 2 }}
						>
							<Typography variant="body1" textAlign="center">
								Average Response Time
							</Typography>
							<Typography
								variant="h1"
								color="warning.Warning_Dk"
								textAlign="center"
							>
								{requestData.AvgResponseTime} Hrs
							</Typography>
						</Box>
					</Grid>
				</Grid>
				<br></br>

				<Stack spacing={2} direction="row" alignItems="flex-end" sx={{ flexWrap: "wrap", gap: 2 }}>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<Stack spacing={1} sx={{ minWidth: 220 }}>
							<Typography variant="body2">Start Date</Typography>
							<DesktopDatePicker
								inputFormat="MM/DD/YYYY"
								value={startDate}
								onChange={(newValue) => {
									setStartDate(newValue);
									setPage(0);
								}}
								renderInput={(params) => (
									<StyledTextBox {...params} size="small" fullWidth />
								)}
							/>
						</Stack>
						<Stack spacing={1} sx={{ minWidth: 220 }}>
							<Typography variant="body2">End Date</Typography>
							<DesktopDatePicker
								inputFormat="MM/DD/YYYY"
								value={endDate}
								onChange={(newValue) => {
									setEndDate(newValue);
									setPage(0);
								}}
								renderInput={(params) => (
									<StyledTextBox {...params} size="small" fullWidth />
								)}
							/>
						</Stack>
					</LocalizationProvider>

					<Stack spacing={1} sx={{ minWidth: 260 }}>
						<Typography variant="body2">Search Record</Typography>
						<StyledTextBox
							fullWidth
							size="small"
							placeholder="Reference ID"
							value={searchRef}
							onChange={(e) => {
								setSearchRef(e.target.value);
								setPage(0);
							}}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											aria-label="search"
											edge="end"
											size="small"
										>
											<SearchIcon />
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</Stack>

					<Stack spacing={1} sx={{ minWidth: 220 }}>
						<Typography variant="body2">Show Requests</Typography>
						<StyledSelectTextBox
							fullWidth
							size="small"
							value={filterStatus}
							onChange={(e) => {
								setFilterStatus(e.target.value);
								setPage(0);
							}}
						>
							<MenuItem value="ALL" sx={{ fontWeight: "400" }}>
								All Requests
							</MenuItem>
							<MenuItem value="PENDING" sx={{ fontWeight: "400" }}>
								PENDING
							</MenuItem>
							<MenuItem value="IN_PROGRESS" sx={{ fontWeight: "400" }}>
								IN PROGRESS
							</MenuItem>
							<MenuItem value="RESOLVED" sx={{ fontWeight: "400" }}>
								RESOLVED
							</MenuItem>
							<MenuItem value="CANCELLED" sx={{ fontWeight: "400" }}>
								CANCELLED
							</MenuItem>
						</StyledSelectTextBox>
					</Stack>
				</Stack>

				<br></br>

				<StyledTableContainer>
					<Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead>
							<TableRow sx={{ backgroundColor: "#F6F6F6" }}>
								<StyledTableCell align="left">Request Date</StyledTableCell>
								<StyledTableCell align="left">Client ID</StyledTableCell>
								<StyledTableCell align="left">Client Name</StyledTableCell>
								<StyledTableCell align="left">Reference ID</StyledTableCell>
								<StyledTableCell align="left">
									Request Catergory
								</StyledTableCell>
								<StyledTableCell align="left">Subject</StyledTableCell>
								<StyledTableCell align="left">Status</StyledTableCell>
								<StyledTableCell align="left">Action</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{displayData
								.sort((a, b) => {
									const dateA = parseRequestDateTime(a.requestDate, a.requestTime);
									const dateB = parseRequestDateTime(b.requestDate, b.requestTime);
									return dateB - dateA;
								})
								.map((row) => (
									<TableRow key={row.referenceNo}>
										<TableCell
											align="left"
											variant="body2"
											sx={{
												borderLeft: `4px solid ${STATUS_BORDER_COLOR[row.status]}`,
											}}
										>
											<Typography variant="body2">
												{row.requestDate}
											</Typography>
											<Typography variant="body3">
												{row.requestTime}
											</Typography>
										</TableCell>
										<TableCell align="left" variant="body2">
											{row.clientId}
										</TableCell>
										<TableCell align="left" variant="body2">
											{row.clientName}
										</TableCell>
										<TableCell align="left" variant="body2">
											{row.referenceNo}
										</TableCell>
										<TableCell
											align="left"
											variant="body2"
											sx={{ color: "#093BA7" }}
										>
											{row.issueType}
										</TableCell>
										<TableCell align="left" variant="body2">
											{row.ticketSubject}
										</TableCell>
										<TableCell align="left" variant="body2">
											{(() => {
												if (row.status === "RESOLVED") {
													return (
														<GreenBox>
															<b>RESOLVED</b>
														</GreenBox>
													);
												} else if (row.status === "IN_PROGRESS") {
													return (
														<BlueBox>
															<b>IN PROGRESS</b>
														</BlueBox>
													);
												} else if (row.status === "CANCELLED") {
													return (
														<RedBox>
															<b>CANCELLED</b>
														</RedBox>
													);
												} else if (row.status === "PENDING") {
													return (
														<YellowBox>
															<b>PENDING</b>
														</YellowBox>
													);
												}
											})()}
										</TableCell>
										<TableCell align="left" variant="body2">
											<TextButton
												onClick={() => {
													setModalValues({
														encryptedId: row.encryptedId,
														ticketreferenceNo: row.referenceNo,
														ticketSubject: row.ticketSubject,
														issueType: row.issueType,
														ticketDescription: row.ticketDescription,
														issueStatus: row.status,
														requestDate: row.requestDate,
														requestTime: row.requestTime
													});
												}}
											>
												View
											</TextButton>
										</TableCell>
									</TableRow>
								))}
							{displayData.length === 0 && (
								<TableRow>
									<TableCell colSpan={8} align="center" variant="body2">
										<Typography variant="body2">No records found</Typography>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</StyledTableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={totalElements}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
				{/* place the modal here */}
				{/* Modal Section of the view  */}
				<Modal
					open={open}
					onClose={handleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Typography
							variant="h3"
							sx={{ textAlign: "center", marginBottom: "1%" }}
						>
							Support Request Ref: <Box component="span" sx={{ fontWeight: 400 }}>{modalValues.ticketreferenceNo}</Box>
						</Typography>
						<Grid container alignItems="center" sx={{ marginBottom: "2%", marginTop: "4%" }}>
							<Grid md={5}>
								<Stack direction="row" spacing={8}>
									<Typography>Request Date</Typography>
									<Typography sx={{ fontWeight: "400" }}>
										{modalValues.requestDate}
									</Typography>
								</Stack>
							</Grid>
							<Grid md={2}></Grid>
							<Grid md={5}>
								<Stack direction="row" spacing={8} justifyContent="center" alignItems="center">
									<Typography>Status</Typography>
									<StyledSelectTextBox
										sx={{ width: "200px" }}
										value={tempStatus}
										onChange={(e) => {
											setTempStatus(e.target.value);
										}}
										disabled={modalValues.issueStatus === "RESOLVED" || modalValues.issueStatus === "CANCELLED"}
									>
										<MenuItem
											value="RESOLVED"
											sx={{ fontWeight: "400" }}
											disabled={modalValues.issueStatus === "PENDING"}
										>
											RESOLVED
										</MenuItem>
										<MenuItem 
											value="IN_PROGRESS" 
											sx={{ fontWeight: "400" }}
											
										>
											IN PROGRESS
										</MenuItem>
										<MenuItem
											value="PENDING"
											sx={{ fontWeight: "400" }}
											disabled={modalValues.issueStatus === "IN_PROGRESS"}
										>
											PENDING
										</MenuItem>
										<MenuItem 
											value="CANCELLED" 
											sx={{ fontWeight: "400" }} 
											disabled={modalValues.issueStatus === "PENDING"}
										>
											CANCELLED
										</MenuItem>
									</StyledSelectTextBox>
								</Stack>
							</Grid>
						</Grid>

						<Grid container alignItems="center">
							<Grid md={5}>
								<Stack direction="row" spacing={8}>
									<Typography>Request Time</Typography>
									<Typography sx={{ fontWeight: "400" }}>{modalValues.requestTime}</Typography>
								</Stack>
							</Grid>
							<Grid md={2}></Grid>
							<Grid md={5}>
								<Stack direction="row" spacing={8} alignItems="center">
									<Typography>Reviewed By</Typography>
									<Avatar src="/broken-image.jpg" sx={{ bgcolor: "#093BA7" }} />
								</Stack>
							</Grid>
						</Grid>
						<Typography
							sx={{ mt: 2, mb: 2, fontWeight: "bold" }}
							variant="body1"
						>
							Request Subject
						</Typography>
						<StyledTextBox
							fullWidth
							// placeholder="lorem ipsum dolar sit a cominuhocs"
							disabled
							value={modalValues.ticketSubject}
						></StyledTextBox>
						<Typography sx={{ mt: 2, mb: 2 }}>Issue Catergory</Typography>
						<StyledTextBox
							disabled
							fullWidth
							value={modalValues.issueType}
						></StyledTextBox>
						<Typography sx={{ mt: 2, mb: 2 }}>Issue Description</Typography>
						<StyledTextArea
							value={modalValues.ticketDescription}
							multiline
							aria-label="minimum height"
							maxRows={6}
							disabled
							style={{ width: "100%" }}
						/>
						<Stack
							direction="row"
							spacing={3}
							sx={{ mt: 4 }}
							justifyContent="center"
						>
							{!(modalValues.issueStatus === "RESOLVED" || modalValues.issueStatus === "CANCELLED") && (
								<ContainedButton
									sx={{ width: "107px" }}
									onClick={handleUpdateStatus}
									disabled={loading}
								>
									{loading ? "Updating..." : "Done"}
								</ContainedButton>
							)}
							<TextButtonModal sx={{ width: "107px" }} onClick={handleClose}>
								Close
							</TextButtonModal>
						</Stack>
					</Box>
				</Modal>
			</Box>
		</div>
	);
}
